import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../store/authSlice';
import Navigation from '../components/Navigation';

function Profile() {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-100 pb-20">
      <div className="bg-gray-700 text-white p-4">
        <button onClick={() => navigate(-1)} className="text-sm mb-2">← Back</button>
        <h2 className="text-xl font-bold">My Profile</h2>
      </div>

      <div className="p-4">
        {/* Profile Card */}
        <div className="bg-white rounded-2xl p-5 shadow text-center">
          <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center text-white text-3xl font-bold mx-auto mb-3">
            {user?.fullName?.charAt(0)?.toUpperCase() || 'U'}
          </div>
          <h3 className="text-xl font-bold text-gray-800">{user?.fullName || 'User'}</h3>
          <p className="text-gray-500">{user?.mobile}</p>
          {user?.email && <p className="text-gray-400 text-sm">{user.email}</p>}
        </div>

        {/* Details */}
        <div className="bg-white rounded-2xl p-4 shadow mt-4 space-y-3">
          <div className="flex justify-between py-2 border-b">
            <span className="text-gray-500">Referral Code</span>
            <span className="font-bold text-blue-600">{user?.referralCode || '-'}</span>
          </div>
          <div className="flex justify-between py-2 border-b">
            <span className="text-gray-500">Account Status</span>
            <span className={`font-semibold ${user?.isActive ? 'text-green-600' : 'text-red-500'}`}>
              {user?.isActive ? 'Active' : 'Inactive'}
            </span>
          </div>
          <div className="flex justify-between py-2 border-b">
            <span className="text-gray-500">Unlocked</span>
            <span className={`font-semibold ${user?.isUnlocked ? 'text-green-600' : 'text-yellow-600'}`}>
              {user?.isUnlocked ? 'Yes' : 'No'}
            </span>
          </div>
          <div className="flex justify-between py-2">
            <span className="text-gray-500">Wallet Balance</span>
            <span className="font-bold">₹{user?.walletBalance || 0}</span>
          </div>
        </div>

        {/* Actions */}
        <div className="mt-6 space-y-3">
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full bg-blue-600 text-white font-bold py-3 rounded-xl"
          >
            Go to Dashboard
          </button>
          <button
            onClick={handleLogout}
            className="w-full bg-red-500 text-white font-bold py-3 rounded-xl"
          >
            Logout
          </button>
        </div>
      </div>

      <Navigation />
    </div>
  );
}

export default Profile;